import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const outputSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});

export const deleteContextLibraryItem = {
  name: "deleteContextLibraryItem" as const,
  input: z.object({ itemId: zExt.objectId() }),
  output: outputSchema as z.ZodType<z.infer<typeof outputSchema>>,
};
